var dvp = dvp || {},
    grecaptcha = grecaptcha || [];

( function () {
    'use strict';
    jQuery( function () {
        dvp.init();
    } );

    dvp.init = function () {
        dvp.header.init();
        dvp.flexTables.init();
        dvp.product.init();
        dvp.videos.init();
        dvp.faq.init();
        dvp.utilities.init();
        dvp.search.init();
        dvp.typeahead.init();
        dvp.events.init();
        dvp.news.init();
        dvp.maps.init();
        dvp.salesContacts.init();
        dvp.animateTxt.init();
        dvp.tooltip.init();
        dvp.forms.init();
        dvp.extranet.init();
        dvp.geoIpRedirect.init();
        dvp.imageAreaMap.init();
        dvp.pageModal.init();
        dvp.timeline.init();
    };
    dvp.animateTxt = {
        init: function () {
            var jTxt = jQuery( '.p-txt-animate' );
            if ( jTxt.length > 0 ) {
                dvp.animateTxt.animate();
                dvp.animateTxt.bindEvents();
            }
        },
        bindEvents: function () {
            dvp.animateTxt.isRAF = false;
            jQuery( window ).on( 'scroll', function () {
                if ( dvp.animateTxt.isRAF === false ) {
                    window.requestAnimationFrame( function () {
                        dvp.animateTxt.animate();
                        dvp.animateTxt.isRAF = false;
                    } );
                    dvp.animateTxt.isRAF = true;
                }
            } );
        },
        animate: function () {
            jQuery( '.p-txt-animate' ).each( function () {
                var jThis = jQuery( this );
                if ( e4.util.isInViewport( jThis ) === true ) {
                    jThis.addClass( 'is-visible' );
                }
            } );
        }

    };
    dvp.header = {
        isRAF: false,
        init: function () {
            dvp.header.fit();
            dvp.header.bindEvents();
            dvp.header.searchbar.bindEvents();
        },
        bindEvents: function () {

            var jBody = jQuery( 'body' ),
                intBodyScrollbarWidth = dvp.header.getBodyScrollBarWidth( jBody ),
                intMegamenuContainerScrollbarWidth = 0,
                intScrollTop = document.documentElement.scrollTop,
                boolHasBodyScrollbar = intBodyScrollbarWidth > 0 ? true : false,
                boolHasMegamenuContainerScrollbar = false;

            jQuery( window ).on( 'load resize', function () {
                if ( dvp.header.isRAF === false ) {
                    window.requestAnimationFrame( function () {
                        dvp.header.fit();
                        dvp.header.isRAF = false;
                    } );
                    dvp.header.isRAF = true;
                }
            } );
            jQuery( '.e-dropdown-mega' ).on( 'shown.bs.dropdown hidden.bs.dropdown', function ( e ) {
                if ( e.relatedTarget.localName !== 'button' ) {
                    if ( e.type === 'shown' && boolHasBodyScrollbar ) {
                        intMegamenuContainerScrollbarWidth = dvp.header.getElementScrollBarWidth( jQuery( e.target ).find( '.e-megamenu-container' ) );

                        boolHasMegamenuContainerScrollbar = intMegamenuContainerScrollbarWidth > 0 ? true : false;

                        if ( boolHasMegamenuContainerScrollbar ) {
                            intScrollTop = document.documentElement.scrollTop;
                            jBody.addClass( 'no-sroll' );
                        }
                    }
                    else if ( e.type === 'hidden' && boolHasBodyScrollbar ) {
                        if ( boolHasMegamenuContainerScrollbar ) {
                            jBody.removeClass( 'no-sroll' );
                            document.documentElement.scrollTop = intScrollTop;
                        }
                    }
                }
            } );
        },
        getBodyScrollBarWidth: function ( jElement ) {

            var intCurrentWidth = jElement.width();

            jElement.css( 'overflow', 'hidden' );
            var intScrollbarWidth = jElement.width() - intCurrentWidth;
            jElement.css( 'overflow', '' );

            return intScrollbarWidth;
        },
        getElementScrollBarWidth: function ( jElement ) {

            var intCurrentWidth = jElement[ 0 ].scrollWidth,
                intOffsetWidth = jElement[ 0 ].offsetWidth;

            var intScrollbarWidth = intOffsetWidth - intCurrentWidth;

            return intScrollbarWidth;
        },
        fit: function () {
            var jHeader = jQuery( '.js-e-header' ),
                jCanvas = jQuery( '#js-e-canvas' ),
                jMegamenuContainer = jQuery( '.e-megamenu-container' );

            for ( var i = 0; i < 5; i++ ) {
                setTimeout( function () {
                    jCanvas.css( 'padding-top', Math.floor( jHeader.height() - 1 ) );
                }, 60 * i );
            }
            if ( window.innerWidth > 991 ) {
                jMegamenuContainer.css( 'max-height', Math.floor( jQuery( window ).height() - jHeader.height() ) );
            }
        },
        searchbar: {
            bindEvents: function () {
                jQuery( '.js-dvp-typeahead-form' ).on( 'submit', function ( e ) {
                    e.preventDefault();
                    var dvpSearchbarValue = jQuery( '.js-dvp-header-search-input' ).val();
                    e4.util.hash.set( 'search', dvpSearchbarValue );
                } ).find( '.js-dvp-header-search-input' ).on( 'input', function () {
                    dvp.header.searchbar.toggleInputGroupState( this );
                } );
                jQuery( '.js-trigger-search' ).on( 'click', function ( e ) {
                    e.preventDefault();
                    jQuery( '.js-dvp-typeahead-form' ).trigger( 'submit' );
                } );
                jQuery( '.js-dvp-search-clear' ).on( 'click', function () {
                    dvp.header.searchbar.clearInput( this );
                } );
            },
            toggleInputGroupState: function ( domElm ) {
                var jSearchInputGroup = jQuery( domElm ).closest( '.js-dvp-search-container' ).find( '.js-dvp-search-action-group' );
                if ( domElm.value === '' ) {
                    jSearchInputGroup.addClass( 'is-empty' );
                }
                else {
                    jSearchInputGroup.removeClass( 'is-empty' );
                }
            },
            clearInput: function ( domElm ) {
                jQuery( domElm ).closest( '.js-dvp-search-container' ).find( '.js-dvp-header-search-input' ).val( '' ).trigger( 'focus' ).triggerHandler( 'input' );
            }
        }
    };
    dvp.flexTables = {
        init: function () {
            dvp.flexTables.addStripes();
        },
        addStripes: function () {
            jQuery( '.flex-table--stripe' ).each( function () {
                jQuery( this ).find( '.cell' ).each( function () {
                    var order = jQuery( this ).attr( 'style' ).match( /\d+/g )[ 0 ];
                    if ( order % 2 === 0 ) {
                        jQuery( this ).addClass( 'is-striped' );
                    }
                } );
            } );
        }
    };
    dvp.product = {
        groupJsonByProperty: function ( xs, key ) {
            return xs.reduce( function ( rv, x ) {
                ( rv[ x[ key ] ] = rv[ x[ key ] ] || [] ).push( x );
                return rv;
            }, {} );
        },
        details: function ( data ) {
            jQuery( '#js-dvp-product-details' ).html( e4.handlebars.tmpl.dvpProductDetails( data ) );
            setTimeout( function () {
                jQuery( '.js-dvp-product-details-animate' ).addClass( 'show' );
            }, 350 );
        },
        footer: function ( data ) {
            jQuery( '#js-dvp-product-footer' ).html( e4.handlebars.tmpl.dvpProductFooter( data ) );
        },
        scrollToRequestInfoForm: function () {
            if ( jQuery( '.js-dvp-product-details-more-info-section' ).length > 0 ) {
                jQuery( '#js-dvp-product-details' ).on( 'click', '.js-dvp-product-details-more-info-btn', function () {
                    var intScrollTarget = jQuery( '.js-dvp-product-details-more-info-section' ).offset().top;
                    e4.scrollToAnchor.animate( Math.max( intScrollTarget, 0 ) );
                } );

            }
        },
        init: function () {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'compare' );
                e4.handlebars.registerHelpers( 'math' );
                if ( jQuery( '.js-dvp-product-details-search-values' ).length > 0 ) {
                    if ( jQuery( '#js-e-handlebars-tmpl-dvp-product-details' ).length > 0 ) {
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-product-details #js-e-handlebars-tmpl-dvp-product-footer' );
                        if ( e4.util.hash.getCurrentHashStringValue() !== '' && location.hash.indexOf( '/' ) === -1 ) {
                            setTimeout( function () {
                                jQuery( 'a[data-productname="' + e4.util.hash.getCurrentHashStringValue() + '"]' ).trigger( 'click' );
                            }, 350 );
                        }
                        else {
                            setTimeout( function () {
                                jQuery( '.js-dvp-product-list-details' ).first().trigger( 'click' );
                            }, 350 ); 
                        }

                        jQuery( '.js-dvp-product-list-details' ).on( 'click', function ( e ) {
                            e.preventDefault();
                            var jThis = jQuery( this ),
                                strTitle = jThis.attr( 'title' ),
                                strGetClass = jThis.data( 'productname' ),
                                strProductJson = jQuery( '.' + strGetClass ).html(),
                                jDvpProductListDetails = jQuery( '.dvp-product-list-details' );

                            jDvpProductListDetails.removeClass( 'active-product' );
                            history.replaceState( {}, strTitle, jThis.attr( 'href' ) );
                            document.title = strTitle;
                            jQuery( '.dvp-product-list-details', this ).addClass( 'active-product' );
                            dvp.product.details( JSON.parse( strProductJson ) );
                            dvp.product.footer( JSON.parse( strProductJson ) );
                            if ( jQuery( '.js-dvp-specific-diet-tabs' ).length > 0 ) {
                                jQuery( '.js-dvp-specific-diet-tabs[href="#tab-details-' + strGetClass + '"]' ).tab( 'show' );
                                jQuery( '.js-dvp-specific-diet-tabs[href="#tab-feeding-' + strGetClass + '"]' ).tab( 'show' );
                            }
                            e4.bootstrap.carousel.init();
                        } );
                    }
                    var jDvpProductDetailsSearchValues = jQuery( '.js-dvp-product-details-search-values' ),
                        strRangeId = jDvpProductDetailsSearchValues.data( 'range-id' ),
                        strTherapyAreaId = jDvpProductDetailsSearchValues.data( 'therapyarea-id' );

                    if ( jQuery( '#js-dvp-product-supportmaterials-vets' ).length > 0 ) {
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-product-supportmaterials-vets' );
                    }
                    if ( jQuery( '#js-dvp-product-supportmaterials-clients' ).length > 0 ) {
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-product-supportmaterials-clients' );
                    }
                    if ( jQuery( '#js-dvp-product-elearning' ).length > 0 ) {
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-product-elearning' );
                    }
                    if ( jQuery( '#js-dvp-product-websites' ).length > 0 ) {
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-product-websites' );
                    }

                    jQuery.getJSON( e4.settings.ecom.product.details.url + '?ri=' + strRangeId + '&ta=' + strTherapyAreaId, function ( data ) {
                        if ( jQuery( '#js-dvp-product-supportmaterials-vets' ).length > 0 ) {
                            if ( !jQuery.isEmptyObject( data.vetSupportmaterials ) ) {
                                jQuery( '#js-dvp-product-supportmaterials-vets' ).html( e4.handlebars.tmpl.dvpProductSupportmaterialsVets( data ) );
                                setTimeout( function () {
                                    jQuery( '.js-dvp-product-supportmaterials-vets-animate' ).addClass( 'show' );
                                }, 350 );
                            }
                            else {
                                jQuery( '#js-dvp-product-supportmaterials-vets' ).html( '' );
                            }
                        }
                        if ( jQuery( '#js-dvp-product-supportmaterials-clients' ).length > 0 ) {
                            if ( !jQuery.isEmptyObject( data.clientSupportmaterials ) ) {
                                jQuery( '#js-dvp-product-supportmaterials-clients' ).html( e4.handlebars.tmpl.dvpProductSupportmaterialsClients( data ) );
                                setTimeout( function () {
                                    jQuery( '.js-dvp-product-supportmaterials-clients-animate' ).addClass( 'show' );
                                }, 350 );
                            }
                            else {
                                jQuery( '#js-dvp-product-supportmaterials-clients' ).html( '' );
                            }
                        }

                        if ( jQuery( '#js-dvp-product-elearning' ).length > 0 ) {
                            if ( !jQuery.isEmptyObject( data.elearning ) ) {
                                jQuery( '#js-dvp-product-elearning' ).html( e4.handlebars.tmpl.dvpProductElearning( data ) );
                                setTimeout( function () {
                                    jQuery( '.js-dvp-product-elearning-animate' ).addClass( 'show' );
                                }, 350 );
                            }
                            else {
                                jQuery( '#js-dvp-product-elearning' ).html( '' );
                            }
                        }
                        if ( jQuery( '#js-dvp-product-websites' ).length > 0 ) {
                            if ( !jQuery.isEmptyObject( data.websites ) ) {
                                jQuery( '#js-dvp-product-websites' ).html( e4.handlebars.tmpl.dvpProductWebsites( data ) );
                                setTimeout( function () {
                                    jQuery( '.js-dvp-product-websites-animate' ).addClass( 'show' );
                                }, 350 );
                            }
                            else {
                                jQuery( '#js-dvp-product-websites' ).html( '' );
                            }
                        }
                    } );

                    if ( jQuery( '#js-dvp-product-premium-content' ).length > 0 ) {
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-product-premium-content #js-e-handlebars-tmpl-dvp-product-premium-content-highlight #js-e-handlebars-tmpl-dvp-product-previous-premium-content' );
                        jQuery.getJSON( e4.settings.search.premiumpages.url + '?ri=' + strRangeId, function ( data ) {
                            if ( !jQuery.isEmptyObject( data.premiumPages ) ) {

                                var objGroupedPremiumPages = dvp.product.groupJsonByProperty( data.premiumPages, 'previousCampaign' );

                                if ( objGroupedPremiumPages.false !== undefined && objGroupedPremiumPages.false.length > 0 ) {
                                    var objNewPremiumPages = {
                                        premiumPages: objGroupedPremiumPages.false
                                    };
                                    jQuery( '#js-dvp-product-premium-content-highlight' ).html( e4.handlebars.tmpl.dvpProductPremiumContentHighlight( objNewPremiumPages ) );
                                    jQuery( '#js-dvp-product-premium-content' ).html( e4.handlebars.tmpl.dvpProductPremiumContent( objNewPremiumPages ) );

                                    jQuery( '#js-dvp-product-premium-content-highlight' ).on( 'click', '.js-dvp-product-details-premium-content-highlight-banner-link', function () {
                                        var intScrollTarget = jQuery( '#js-dvp-product-premium-content' ).offset().top;
                                        e4.scrollToAnchor.animate( Math.max( intScrollTarget, 0 ) );
                                    } );
                                    setTimeout( function () {
                                        jQuery( '.js-dvp-product-premium-content-animate' ).addClass( 'show' );
                                    }, 350 );
                                }
                                else {
                                    jQuery( '#js-dvp-product-premium-content-highlight' ).html( '' );
                                    jQuery( '#js-dvp-product-premium-content' ).html( '' );
                                }
                                if ( objGroupedPremiumPages.true !== undefined && objGroupedPremiumPages.true.length > 0 ) {
                                    var objOldPremiumPages = {
                                        premiumPages: objGroupedPremiumPages.true
                                    };
                                    jQuery( '#js-dvp-product-previous-premium-content' ).html( e4.handlebars.tmpl.dvpProductPreviousPremiumContent( objOldPremiumPages ) );

                                    setTimeout( function () {
                                        jQuery( '.js-dvp-product-previous-premium-content-animate' ).addClass( 'show' );
                                    }, 350 );
                                }
                                else {
                                    jQuery( '#js-dvp-product-previous-premium-content' ).html( '' );
                                }
                            }
                            else {
                                jQuery( '#js-dvp-product-premium-content-highlight' ).html( '' );
                                jQuery( '#js-dvp-product-premium-content' ).html( '' );
                                jQuery( '#js-dvp-product-previous-premium-content' ).html( '' ); 
                            }
                        } );
                    }

                    if ( jQuery( '#js-dvp-product-videos' ).length > 0 ) {
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-product-videos' );
                        jQuery.getJSON( e4.settings.search.videos.url + '?ri=' + strRangeId, function ( data ) {
                            if ( !jQuery.isEmptyObject( data.videos ) ) {
                                jQuery( '#js-dvp-product-videos' ).html( e4.handlebars.tmpl.dvpProductVideos( data ) );
                                setTimeout( function () {
                                    dvp.videos.modal();
                                    jQuery( '.js-dvp-product-videos-animate' ).addClass( 'show' );
                                }, 350 );
                            }
                            else {
                                jQuery( '#js-dvp-product-videos' ).html( '' );
                            }
                        } );
                        jQuery( '#js-dvp-product-videos' ).on( 'click', '.collapse-peek-content', function () {
                            if ( !jQuery( this ).hasClass( 'show' ) ) {
                                jQuery( this ).parent().find( '.collapse-peek-btn-show' ).trigger( 'click' );
                            }
                        } );
                    }

                    if ( jQuery( '#js-dvp-product-faq' ).length > 0 ) {
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-product-faq' );
                        jQuery.getJSON( e4.settings.search.faq.url + '?ri=' + strRangeId, function ( data ) {
                            if ( !jQuery.isEmptyObject( data.faqs ) ) {
                                jQuery( '#js-dvp-product-faq' ).html( e4.handlebars.tmpl.dvpProductFaq( data ) );
                                setTimeout( function () {
                                    dvp.faq.modal();
                                    jQuery( '.js-dvp-product-faq-animate' ).addClass( 'show' );
                                }, 350 );
                            }
                            else {
                                jQuery( '#js-dvp-product-faq' ).html( '' );
                            }
                        } );
                    }
                    dvp.product.scrollToRequestInfoForm();
                }
            } );
        }
    };
    dvp.therapyareas = {
        search: {
            count: 0,
            get: function ( domElm, therapyAreaIds ) {
                dvp.therapyareas.search.count = 0;
                dvp.therapyareas.search.hide( domElm );
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    this.jqXHR.abort();
                }
                this.jqXHR = jQuery.ajax( {
                    url: e4.settings.search.therapyareas.url,
                    data: {
                        q: domElm.value.toLowerCase(),
                        ta: therapyAreaIds
                    },
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                } );
                this.jqXHR.done( function ( data ) {
                    dvp.therapyareas.search.update( domElm, data );
                } );
                return this.jqXHR;
            },
            abort: function () {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    return this.jqXHR.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function ( domElm, data ) {
                if ( !jQuery.isEmptyObject( data.therapyareas ) ) {
                    dvp.therapyareas.search.count = data.therapyareas.length;
                    dvp.therapyareas.search.show( domElm, data );
                }
            },
            show: function ( domElm, data ) {
                if ( dvp.therapyareas.search.count > 0 ) {
                    var jSearch = jQuery( domElm ).closest( '.js-e-search' );
                    jSearch.find( '.js-dvp-search-therapy-areas' ).html( e4.handlebars.tmpl.dvpSearchTherapyareas( data ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-e-search-therapyarea-count' ).text( dvp.therapyareas.search.count );
                    dvp.search.menu.show( jQuery( jSearch ).find( '.js-dvp-search-therapy-areas' ).attr( 'id' ) );
                }
                else {
                    dvp.therapyareas.search.hide( domElm );
                }
            },
            hide: function ( domElm ) {
                jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-therapy-areas' ).addClass( 'is-empty' ).html( '' );
                dvp.search.menu.hide( jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-therapy-areas' ).attr( 'id' ) );
            }
        }
    };
    dvp.supportmaterials = {
        search: {
            count: 0,
            get: function ( domElm, rangeIds ) {
                dvp.supportmaterials.search.count = 0;
                dvp.supportmaterials.search.hide( domElm );
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    this.jqXHR.abort();
                }
                this.jqXHR = jQuery.ajax( {
                    url: e4.settings.search.supportmaterials.url,
                    data: {
                        q: domElm.value.toLowerCase(),
                        ri: rangeIds
                    },
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                } );
                this.jqXHR.done( function ( data ) {
                    dvp.supportmaterials.search.update( domElm, data );
                } );
                return this.jqXHR;
            },
            abort: function () {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    return this.jqXHR.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function ( domElm, data ) {
                if ( !jQuery.isEmptyObject( data.supportmaterials ) ) {
                    for ( var i = 0; i < data.supportmaterials.length; i++ ) {
                        dvp.supportmaterials.search.count += data.supportmaterials[ i ].count;
                    }
                    dvp.supportmaterials.search.show( domElm, data );
                }
            },
            show: function ( domElm, data ) {
                if ( dvp.supportmaterials.search.count > 0 ) {
                    var jSearch = jQuery( domElm ).closest( '.js-e-search' );
                    jSearch.find( '.js-dvp-search-supportmaterials' ).html( e4.handlebars.tmpl.dvpSearchSupportmaterials( data ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-e-search-supportmaterials-count' ).text( dvp.supportmaterials.search.count );
                    dvp.search.menu.show( jQuery( jSearch ).find( '.js-dvp-search-supportmaterials' ).attr( 'id' ) );
                }
                else {
                    dvp.supportmaterials.search.hide( domElm );
                }
            },
            hide: function ( domElm ) {
                jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-supportmaterials' ).addClass( 'is-empty' ).html( '' );
                dvp.search.menu.hide( jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-supportmaterials' ).attr( 'id' ) );
            }
        }
    };
    dvp.elearning = {
        search: {
            count: 0,
            get: function ( domElm, rangeIds ) {
                dvp.elearning.search.count = 0;
                dvp.elearning.search.hide( domElm );
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    this.jqXHR.abort();
                }
                this.jqXHR = jQuery.ajax( {
                    url: e4.settings.search.elearning.url,
                    data: {
                        q: domElm.value.toLowerCase(),
                        ri: rangeIds
                    },
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                } );
                this.jqXHR.done( function ( data ) {
                    dvp.elearning.search.update( domElm, data );
                } );
                return this.jqXHR;
            },
            abort: function () {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    return this.jqXHR.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function ( domElm, data ) {
                if ( !jQuery.isEmptyObject( data.supportmaterials ) ) {
                    dvp.elearning.search.count = data.supportmaterials[ 0 ].count;
                    dvp.elearning.search.show( domElm, data );
                }
            },
            show: function ( domElm, data ) {
                if ( dvp.elearning.search.count > 0 ) {
                    var jSearch = jQuery( domElm ).closest( '.js-e-search' );
                    jSearch.find( '.js-dvp-search-elearning' ).html( e4.handlebars.tmpl.dvpSearchElearning( data ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-e-search-elearning-count' ).text( dvp.elearning.search.count );
                    dvp.search.menu.show( jQuery( jSearch ).find( '.js-dvp-search-elearning' ).attr( 'id' ) );
                }
                else {
                    dvp.elearning.search.hide( domElm );
                }
            },
            hide: function ( domElm ) {
                jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-elearning' ).addClass( 'is-empty' ).html( '' );
                dvp.search.menu.hide( jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-elearning' ).attr( 'id' ) );
            }
        }
    };
    dvp.videos = {
        search: {
            count: 0,
            get: function ( domElm, rangeIds, therapyAreaIds ) {
                dvp.videos.search.count = 0;
                dvp.videos.search.hide( domElm );
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    this.jqXHR.abort();
                }
                this.jqXHR = jQuery.ajax( {
                    url: e4.settings.search.videos.url,
                    data: {
                        q: domElm.value.toLowerCase(),
                        ta: therapyAreaIds
                    },
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                } );
                this.jqXHR.done( function ( data ) {
                    dvp.videos.search.update( domElm, data );
                } );
                return this.jqXHR;
            },
            abort: function () {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    return this.jqXHR.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function ( domElm, data ) {
                if ( !jQuery.isEmptyObject( data.videos ) ) {
                    for ( var i = 0; i < data.videos.length; i++ ) {
                        dvp.videos.search.count += data.videos[ i ].videoCount;
                    }
                    dvp.videos.search.show( domElm, data );
                }
            },
            show: function ( domElm, data ) {
                if ( dvp.videos.search.count > 0 ) {
                    var jSearch = jQuery( domElm ).closest( '.js-e-search' ),
                        intMaxResults = 3,
                        dataSliced = {
                            display: data.display,
                            videos: data.videos.slice( 0, intMaxResults ),
                            showMoreCount: data.videos.length - intMaxResults
                        };
                    jSearch.find( '.js-dvp-search-videos' ).html( e4.handlebars.tmpl.dvpSearchVideos( dataSliced ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-e-search-videos-count' ).text( dvp.videos.search.count );
                    dvp.search.menu.show( jQuery( jSearch ).find( '.js-dvp-search-videos' ).attr( 'id' ) );
                    dvp.videos.search.toggleShowAll( domElm, data, intMaxResults );
                    setTimeout( function () {
                        dvp.videos.modal();
                    }, 350 );
                }
                else {
                    dvp.videos.search.hide( domElm );
                }
            },
            hide: function ( domElm ) {
                jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-videos' ).addClass( 'is-empty' ).html( '' );
                dvp.search.menu.hide( jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-videos' ).attr( 'id' ) );
            },
            toggleShowAll: function ( domElm, data, intMaxResults ) {
                var jShowAll = jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-videos-show-all' );
                if ( data.videos.length > intMaxResults ) {
                    jShowAll.find( 'a' ).attr( 'href', e4.settings.search.result.products.showAllLink ).on( 'click', {
                        'domElm': domElm,
                        'videos': data
                    }, dvp.videos.search.showAll );
                }
                else {
                    jShowAll.addClass( 'd-none' );
                    jShowAll.find( 'a' ).off( 'click', dvp.videos.search.showAll );
                }
            },
            showAll: function ( event ) {
                if ( dvp.videos.search.count > 0 && event.data !== undefined ) {
                    event.preventDefault();
                    var jSearch = jQuery( event.data.domElm ).closest( '.js-e-search' );
                    jSearch.find( '.js-dvp-search-videos' ).html( e4.handlebars.tmpl.dvpSearchVideos( event.data.videos ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-dvp-search-videos-show-all' ).addClass( 'd-none' );
                    jSearch.find( '.js-e-search-videos-count' ).text( dvp.videos.search.count );
                    dvp.videos.modal();
                }
            }
        },
        modal: function () {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-modal-video-content' );
                jQuery( '.js-dvp-video-modal' ).on( 'click', function () {
                    jQuery( '#js-dvp-modal-video-content' ).html( e4.handlebars.tmpl.dvpModalVideoContent( JSON.parse( jQuery( this ).next( 'script' ).html() ) ) );
                    dvp.utilities.copyToClipboard();
                    jQuery( '.dvp-video-modal' ).modal( 'show' );
                } );
            } );
            jQuery( '.dvp-video-modal' ).on( 'hidden.bs.modal', function () {
                jQuery( '#js-dvp-modal-video-content' ).html( '' );
                if ( jQuery( '.modal.fade:visible' ).length ) {
                    jQuery( 'body' ).addClass( 'modal-open' );
                }
            } );
        },
        init: function () {
            dvp.videos.modal();
        }
    };
    dvp.faq = {
        search: {
            categoryCount: 0,
            count: 0,
            get: function ( domElm, rangeIds ) {
                dvp.faq.search.count = 0;
                dvp.faq.search.hide( domElm );
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    this.jqXHR.abort();
                }
                this.jqXHR = jQuery.ajax( {
                    url: e4.settings.search.faq.url,
                    data: {
                        q: domElm.value.toLowerCase(),
                        ri: rangeIds
                    },
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                } );
                this.jqXHR.done( function ( data ) {
                    dvp.faq.search.update( domElm, data );
                } );
                return this.jqXHR;
            },
            abort: function () {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    return this.jqXHR.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function ( domElm, data ) {
                if ( !jQuery.isEmptyObject( data.faqs ) ) {
                    for ( var i = 0; i < data.faqs.length; i++ ) {
                        var faq = data.faqs[ i ].faq;
                        dvp.faq.search.categoryCount += data.faqs[ i ].faqCount;

                        for ( var n = 0; n < faq.length; n++ ) {
                            dvp.faq.search.count += faq[ n ].listCount;
                        }
                    }
                    dvp.faq.search.show( domElm, data );
                }
            },
            show: function ( domElm, data ) {
                if ( dvp.faq.search.count > 0 ) {
                    var jSearch = jQuery( domElm ).closest( '.js-e-search' ),
                        intMaxResults = 2,
                        dataSliced = {
                            display: data.display,
                            faqs: data.faqs.slice( 0, intMaxResults )
                        };
                    jSearch.find( '.js-dvp-search-faq' ).html( e4.handlebars.tmpl.dvpSearchFaq( dataSliced ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-e-search-faq-count' ).text( dvp.faq.search.count );
                    dvp.search.menu.show( jQuery( jSearch ).find( '.js-dvp-search-faq' ).attr( 'id' ) );
                    dvp.faq.search.toggleShowAll( domElm, data, intMaxResults );
                    setTimeout( function () {
                        dvp.faq.modal();
                    }, 350 );
                }
                else {
                    dvp.faq.search.hide( domElm );
                }
            },
            hide: function ( domElm ) {
                jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-faq' ).addClass( 'is-empty' ).html( '' );
                dvp.search.menu.hide( jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-faq' ).attr( 'id' ) );
            },
            toggleShowAll: function ( domElm, data, intMaxResults ) {
                var jShowAll = jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-faq-show-all' );
                if ( data.faqs.length > intMaxResults ) {
                    jShowAll.find( 'a' ).attr( 'href', e4.settings.search.result.products.showAllLink ).on( 'click', {
                        'domElm': domElm,
                        'faqs': data
                    }, dvp.faq.search.showAll );
                }
                else {
                    jShowAll.addClass( 'd-none' );
                    jShowAll.find( 'a' ).off( 'click', dvp.faq.search.showAll );
                }
            },
            showAll: function ( event ) {
                if ( dvp.faq.search.count > 0 && event.data !== undefined ) {
                    event.preventDefault();
                    var jSearch = jQuery( event.data.domElm ).closest( '.js-e-search' );
                    jSearch.find( '.js-dvp-search-faq' ).html( e4.handlebars.tmpl.dvpSearchFaq( event.data.faqs ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-dvp-search-faq-show-all' ).addClass( 'd-none' );
                    jSearch.find( '.js-e-search-faq-count' ).text( dvp.faq.search.count );
                }
            }
        },
        responsiveIframe: function () {
            jQuery( '.dvp-rich-text-content iframe' ).each( function () {
                jQuery( this ).parent().addClass( 'embed-responsive embed-responsive-16by9' );
                jQuery( this ).addClass( 'embed-responsive-item' );
            } );
        },
        modal: function () {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-modal-faq-content' );
                jQuery( '.js-dvp-faq-modal' ).on( 'click', function () {
                    jQuery( '#js-dvp-modal-faq-content' ).html( e4.handlebars.tmpl.dvpModalFaqContent( JSON.parse( jQuery( this ).next( 'script' ).html() ) ) );
                    dvp.faq.responsiveIframe();
                    dvp.utilities.copyToClipboard();
                    dvp.utilities.printElement();
                    jQuery( '.dvp-faq-modal' ).modal( 'show' );
                } );
            } );
            jQuery( '.dvp-faq-modal' ).on( 'hidden.bs.modal', function () {
                jQuery( '#js-dvp-modal-faq-content' ).html( '' );
                if ( jQuery( '.modal.fade:visible' ).length ) {
                    jQuery( 'body' ).addClass( 'modal-open' );
                }
            } );
        },
        init: function () {
            if ( jQuery( '.dvp-rich-text-content iframe' ).length > 0 ) {
                dvp.faq.responsiveIframe();
            }
            dvp.faq.modal();
        }
    };
    dvp.search = {
        menu: {
            show: function ( element ) {
                jQuery( '.js-dvp-search-menu' ).find( 'a[data-scrollto="' + element + '"]' ).removeClass( 'd-none' );
            },
            hide: function ( element ) {
                jQuery( '.js-dvp-search-menu' ).find( 'a[data-scrollto="' + element + '"]' ).addClass( 'd-none' );
            },
            scrollTo: function () {
                jQuery( '.js-dvp-search-menu' ).on( 'click', 'a', function () {
                    var childPos = jQuery( '#' + jQuery( this ).data( 'scrollto' ) ).offset();
                    var parentPos = jQuery( '.js-e-search-modal .modal-dialog' ).offset();

                    var childOffset = {
                        top: childPos.top - parentPos.top
                    };

                    jQuery( '.js-e-search-modal' ).animate( {
                        scrollTop: ( childOffset.top - 20 )
                    } );
                } );
            }
        },
        init: function () {
            dvp.search.menu.scrollTo();
        }
    };
    dvp.utilities = {
        copyToClipboard: function () {
            jQuery( '.js-copy-to-clipboard' ).on( 'click', function () {
                var temp = jQuery( '<input>' );
                jQuery( 'body' ).append( temp );
                temp.val( jQuery( this ).attr( 'href' ) ).select();
                document.execCommand( 'copy' );
                temp.remove();
            } );
        },
        printElement: function () {
            jQuery( '.js-print' ).on( 'click', function () {
                window.print();
            } );
        },
        init: function () {
            dvp.utilities.copyToClipboard();
        }
    };
    dvp.typeahead = {
        init: function () {
            if ( e4.settings.search.result.products.show === true ) {
                if ( jQuery( '.js-dvp-header-search-input' ).length > 0 ) {
                    e4.util.require.js( e4.settings.require.typeahead, function () {
                        dvp.typeahead.bindEvents();
                    } );
                }
            }
        },
        bindEvents: function () {
            jQuery( '.js-dvp-header-search-input' ).on( 'keydown', function ( event ) {
                if ( event.keyCode === 13 ) {
                    var jSuggestions = jQuery( this.form ).find( '.js-dvp-suggestions' ),
                        jSuggestionActive = jSuggestions.find( '.tt-selectable' ).filter( '.active' );
                    if ( jSuggestionActive.length === 0 && jSuggestions.css( 'display' ) === 'block' ) {
                        jQuery( this.form ).triggerHandler( 'submit' );
                    }
                }
            } ).typeahead( {
                hint: false,
                highlight: true,
                minLength: 2,
                classNames: {
                    wrapper: 'dvp-typeahead-wrapper js-dvp-typeahead-wrapper w-100',
                    input: 'js-dvp-header-search-input',
                    menu: 'js-dvp-suggestions dvp-suggestions dropdown-menu w-100',
                    suggestion: 'js-dvp-suggestions-item dropdown-item text-truncate',
                    open: 'open',
                    cursor: 'active',
                    highlight: 'active'
                }
            }, {
                name: 'typeahead',
                limit: 8,
                async: true,
                source: function ( query, syncResults, asyncResults ) {
                    dvp.typeahead.getSuggestions( query, function ( data ) {
                        asyncResults( data );
                    } );
                },
                display: function ( suggestion ) {
                    return suggestion.keyword;
                }
            } ).on( 'typeahead:autocomplete typeahead:select', function ( event, value ) { // typeahead:cursorchange
                if ( value !== null ) {
                    jQuery( this ).typeahead( 'close' );
                    jQuery( this.form ).triggerHandler( 'submit' );
                }
            } );
        },
        getSuggestions: function ( query, asyncResults ) {
            if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                this.jqXHR.abort();
            }
            query = jQuery.trim( query );
            if ( query !== '' ) {
                this.jqXHR = jQuery.ajax( {
                    type: 'GET',
                    url: e4.settings.search.typeahead.url,
                    data: {
                        q: query
                    },
                    dataType: 'json'
                } );
                this.jqXHR.done( function ( data ) {
                    asyncResults( data.keywords );
                } );
            }
        }
    };
    dvp.events = {
        filter: {
            month: function () {
                if ( jQuery( '.js-dvp-event-filter' ).length > 0 ) {
                    jQuery( '.js-dvp-event-filter' ).on( 'click', '.nav-link', function () {
                        jQuery( '.js-dvp-event-filter' ).find( '.nav-link' ).each( function () {
                            jQuery( this ).removeClass( 'active' );
                        } );

                        jQuery( this ).addClass( 'active' );

                        var jLink = jQuery( this ).data( 'month-filter' );

                        if ( jLink !== 'ALL' ) {
                            jQuery( '.js-dvp-event-list' ).each( function () {
                                if ( jQuery( this ).data( 'month-filter' ) !== jLink ) {
                                    jQuery( this ).hide();
                                }
                                else {
                                    jQuery( this ).show();
                                }
                            } );
                        }
                        else {
                            jQuery( '.js-dvp-event-list' ).show();
                        }

                    } );
                }
            }
        },
        search: {
            count: 0,
            get: function ( domElm ) {
                dvp.events.search.count = 0;
                dvp.events.search.hide( domElm );
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    this.jqXHR.abort();
                }
                this.jqXHR = jQuery.ajax( {
                    url: e4.settings.search.events.url,
                    data: {
                        q: domElm.value.toLowerCase()
                    },
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                } );
                this.jqXHR.done( function ( data ) {
                    dvp.events.search.update( domElm, data );
                } );
                return this.jqXHR;
            },
            abort: function () {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    return this.jqXHR.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function ( domElm, data ) {
                if ( !jQuery.isEmptyObject( data.events ) ) {
                    dvp.events.search.count = data.events.length;
                    dvp.events.search.show( domElm, data );
                }
            },
            show: function ( domElm, data ) {
                if ( dvp.events.search.count > 0 ) {
                    var jSearch = jQuery( domElm ).closest( '.js-e-search' );
                    jSearch.find( '.js-dvp-search-events' ).html( e4.handlebars.tmpl.dvpSearchEvents( data ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-e-search-events-count' ).text( dvp.events.search.count );
                    dvp.search.menu.show( jQuery( jSearch ).find( '.js-dvp-search-events' ).attr( 'id' ) );
                    dvp.flexTables.init();
                }
                else {
                    dvp.events.search.hide( domElm );
                }
            },
            hide: function ( domElm ) {
                jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-events' ).addClass( 'is-empty' ).html( '' );
                dvp.search.menu.hide( jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-events' ).attr( 'id' ) );
            }
        },
        init: function () {
            dvp.events.filter.month();
        }
    };
    dvp.news = {
        filter: {
            month: function () {
                if ( jQuery( '.js-dvp-news-filter' ).length > 0 ) {
                    jQuery( '.js-dvp-news-filter' ).on( 'click', '.nav-link', function () {
                        jQuery( '.js-dvp-news-filter' ).find( '.nav-link' ).each( function () {
                            jQuery( this ).removeClass( 'active' );
                        } );

                        jQuery( this ).addClass( 'active' );

                        var jLink = jQuery( this ).data( 'month-filter' );

                        if ( jLink !== 'ALL' ) {
                            jQuery( '.js-dvp-news-list' ).each( function () {
                                if ( jQuery( this ).data( 'month-filter' ) !== jLink ) {
                                    jQuery( this ).hide();
                                }
                                else {
                                    jQuery( this ).show();
                                }
                            } );
                        }
                        else {
                            jQuery( '.js-dvp-news-list' ).show();
                        }

                    } );
                }
            }
        },
        search: {
            count: 0,
            get: function ( domElm ) {
                dvp.news.search.count = 0;
                dvp.news.search.hide( domElm );
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    this.jqXHR.abort();
                }
                this.jqXHR = jQuery.ajax( {
                    url: e4.settings.search.news.url,
                    data: {
                        q: domElm.value.toLowerCase()
                    },
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                } );
                this.jqXHR.done( function ( data ) {
                    dvp.news.search.update( domElm, data );
                } );
                return this.jqXHR;
            },
            abort: function () {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    return this.jqXHR.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function ( domElm, data ) {
                if ( !jQuery.isEmptyObject( data.news ) ) {
                    dvp.news.search.count = data.news.length;
                    dvp.news.search.show( domElm, data );
                }
            },
            show: function ( domElm, data ) {
                if ( dvp.news.search.count > 0 ) {
                    var jSearch = jQuery( domElm ).closest( '.js-e-search' );
                    jSearch.find( '.js-dvp-search-news' ).html( e4.handlebars.tmpl.dvpSearchNews( data ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-e-search-news-count' ).text( dvp.news.search.count );
                    dvp.search.menu.show( jQuery( jSearch ).find( '.js-dvp-search-news' ).attr( 'id' ) );
                }
                else {
                    dvp.news.search.hide( domElm );
                }
            },
            hide: function ( domElm ) {
                jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-news' ).addClass( 'is-empty' ).html( '' );
                dvp.search.menu.hide( jQuery( domElm ).closest( '.js-e-search' ).find( '.js-dvp-search-news' ).attr( 'id' ) );
            }
        },
        init: function () {
            dvp.news.filter.month();
        }
    };
    dvp.maps = {
        GoogleMapsAPIkey: '',
        data: {},
        jMap: [],
        gmMap: {},
        countryCode: '',
        gmGeocoder: function () {
        },
        init: function () {
            var jDvpMaps = jQuery( '.js-dvp-maps' );
            if ( jDvpMaps.length === 1 ) {
                dvp.maps.GoogleMapsAPIkey = jDvpMaps.data( 'googlemapsapikey' );
                dvp.maps.jMap = jDvpMaps.find( '.js-dvp-maps-googlemap' );
                dvp.maps.countryCode = jDvpMaps.data( 'countrycode' );
                dvp.maps.getData();
                dvp.maps.apis.load();
            }
        },
        apis: {
            load: function () {
                jQuery.when.apply( jQuery, [
                    dvp.maps.apis.GoogleMaps.load(),
                    dvp.maps.apis.MarkerClusterer.load(),
                    dvp.maps.apis.jQueryUImap.load(),
                    dvp.maps.apis.handlebars.load()
                ] ).then( function () {
                    dvp.maps.map.init();
                } );
            },
            GoogleMaps: {
                timeout: null,
                deferred: jQuery.Deferred(),
                load: function () {
                    if ( window.google !== undefined && google.maps !== undefined ) {
                        return dvp.maps.apis.GoogleMaps.callback();
                    }
                    else {
                        var gm = document.createElement( 'script' ),
                            script = document.getElementsByTagName( 'script' )[ 0 ];
                        gm.src = '//maps.googleapis.com/maps/api/js?key=' + dvp.maps.GoogleMapsAPIkey + '&callback=' + 'dvp.maps.apis.GoogleMaps.callback';
                        script.parentNode.insertBefore( gm, script );
                        dvp.maps.apis.GoogleMaps.timeout = setTimeout( dvp.maps.apis.GoogleMaps.deferred.reject, e4.settings.require.timeout );
                        return dvp.maps.apis.GoogleMaps.deferred.promise();
                    }
                },
                callback: function () {
                    clearTimeout( dvp.maps.apis.GoogleMaps.timeout );
                    dvp.maps.apis.GoogleMaps.timeout = null;
                    dvp.maps.gmGeocoder = new google.maps.Geocoder();
                    return dvp.maps.apis.GoogleMaps.deferred.resolve();
                }
            },
            jQueryUImap: {
                load: function () {
                    return e4.util.require.js( e4.settings.require.jQueryUImap );
                }
            },
            MarkerClusterer: {
                load: function () {
                    return e4.util.require.js( e4.settings.require.MarkerClusterer );
                }
            },
            handlebars: {
                load: function () {
                    return e4.util.require.js( e4.settings.require.handlebars, function () {
                        e4.handlebars.registerHelpers( 'loop' ); //TODO: Refactor using built-in helper each
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-googlemap-infowindow' );
                    } );
                }
            }
        },
        getData: function () {
            var intDealersearchID = jQuery( '.js-dvp-maps' ).data( 'id' );
            dvp.maps.data = dvp.mapsData[ intDealersearchID ].users;
            dvp.mapsData[ intDealersearchID ].users = null;
        },
        map: {
            init: function () {
                dvp.maps.jMap.gmap( {
                    zoom: e4.settings.maps.zoom.initial,
                    center: new google.maps.LatLng( e4.settings.maps.center.initialLat, e4.settings.maps.center.initialLng ),
                    mapTypeControl: false,
                    scrollwheel: false
                } ).on( 'init', function () {
                    dvp.maps.clusterer.init();
                    dvp.maps.markers.init();
                    dvp.maps.map.bindEvents();
                    dvp.maps.map.fitBoundsAndCenter();
                } );
            },
            bindEvents: function () {
                jQuery( window ).on( 'resize', function () {
                    dvp.maps.jMap.gmap( 'refresh' );
                } );

            },
            fitBoundsAndCenter: function () {
                if ( dvp.maps.countryCode === '' ) {
                    //dvp.maps.jMap.gmap( 'get', 'map' ).fitBounds( dvp.maps.markers.bounds );
                    //dvp.maps.jMap.gmap( 'get', 'map' ).setCenter( dvp.maps.markers.bounds.getCenter() );
                }
                else {
                    dvp.maps.gmGeocoder.geocode( {
                        address: dvp.maps.countryCode,
                        componentRestrictions: {
                            country: dvp.maps.countryCode
                        }
                    }, function ( addresses, status ) {
                        if ( status === 'OK' ) {
                            var mapLatLngBounds = e4.dealersearch.map.getBoundsByAddress( addresses[ 0 ] );
                            dvp.maps.jMap.gmap( 'get', 'map' ).fitBounds( mapLatLngBounds );
                        }
                    } );
                }
            }
        },
        clusterer: {
            init: function () {
                dvp.maps.jMap.gmap( 'set', 'MarkerClusterer', new MarkerClusterer( dvp.maps.jMap.gmap( 'get', 'map' ), [], {
                    maxZoom: e4.settings.maps.zoom.max - 1,
                    averageCenter: true,
                    imagePath: '//cdn.rawgit.com/googlemaps/js-marker-clusterer/gh-pages/images/m'
                } ) );
            },
            addMarkers: function () {
                dvp.maps.jMap.gmap( 'get', 'MarkerClusterer' ).addMarkers( dvp.maps.data.markers );
            }
        },
        markers: {
            bounds: function () {
            },
            init: function () {
                dvp.maps.markers.build();
                dvp.maps.clusterer.addMarkers();
                dvp.maps.markers.bindEvents();
            },
            build: function () {
                dvp.maps.data.markers = [];
                dvp.maps.markers.bounds = new google.maps.LatLngBounds();
                jQuery.each( dvp.maps.data, function ( index, user ) {
                    var lat = parseFloat( user.lat ),
                        lng = parseFloat( user.lng );
                    if ( isNaN( lat ) || isNaN( lng ) || Math.abs( lat ) > 90 || Math.abs( lng ) > 180 ) {
                        console.error( 'Error - lat/lng data not valid for this address: ' + user.name + '' );
                    }
                    else {
                        var latLng = new google.maps.LatLng( lat, lng );
                        dvp.maps.data.markers.push( new google.maps.Marker( {
                            id: user.id,
                            position: latLng,
                            data: user,
                            distanceToAddress: 0
                        } ) );
                        dvp.maps.markers.bounds.extend( latLng );
                    }
                } );
            },
            bindEvents: function () {
                jQuery.each( dvp.maps.data.markers, function ( index, marker ) {
                    google.maps.event.addListener( marker, 'click', function () {
                        dvp.maps.jMap.gmap( 'openInfoWindow', {
                            'content': dvp.maps.markers.getInfoWindowContent( marker )
                        }, marker );
                        // TODO: Move to gtm namespace
                        e4.gtm.pushDataLayer( {
                            'eventCategory': 'Map',
                            'eventAction': marker.data.name,
                            'eventLabel': location.pathname,
                            'eventValue': 0,
                            'eventInteraction': false,
                            'event': 'track-ga-event'
                        } );
                    } );
                } );
            },
            getInfoWindowContent: function ( marker ) {
                return e4.handlebars.tmpl.googlemapInfowindow( marker.data );
            },
            showOnMap: function ( marker ) {
                //dvp.maps.markers.clearDistanceToAddress();
                var gmMap = dvp.maps.jMap.gmap( 'get', 'map' );
                gmMap.panTo( marker.getPosition() );
                google.maps.event.trigger( marker, 'click' );
            }
        }
    };
    dvp.salesContacts = {
        init: function () {
            dvp.salesContacts.search.bindEvents();
        },
        search: {
            get: function ( jZip, jName ) {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    this.jqXHR.abort();
                }
                var query = '';

                if ( jZip !== '' ) {
                    query = '?scz=' + jZip;
                }
                else if ( jName !== '' ) {
                    query = '?scn=' + jName;
                }

                if ( query !== '' ) {
                    this.jqXHR = jQuery.ajax( {
                        url: e4.settings.search.salesContacts.url + query,
                        method: 'GET',
                        dataType: 'json'
                    } );
                    this.jqXHR.done( function ( data ) {
                        dvp.salesContacts.search.build( data );
                    } );
                }
            },
            build: function ( data ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-sales-contacts' );
                    jQuery( '.js-dvp-sales-contacts-form-results' ).html( e4.handlebars.tmpl.dvpSalesContacts( data ) );
                } );
            },
            bindEvents: function () {
                var jForm = jQuery( '.js-dvp-sales-contacts-form' );
                if ( jForm.length > 0 ) {
                    jForm.find( '[name="sales-contacts-zip"]' ).on( 'focus', function () {
                        jForm.find( '[name="sales-contacts-name"]' ).val( '' );
                    } );
                    jForm.find( '[name="sales-contacts-name"]' ).on( 'focus', function () {
                        jForm.find( '[name="sales-contacts-zip"]' ).val( '' );
                    } );
                    jForm.on( 'submit', function ( event ) {
                        event.preventDefault();

                        var jZip = jQuery( this ).find( '[name="sales-contacts-zip"]' ).val(),
                            jName = jQuery( this ).find( '[name="sales-contacts-name"]' ).val();

                        dvp.salesContacts.search.get( jZip, jName );
                    } );
                }
            }
        }
    };
    dvp.tooltip = {
        init: function () {
            jQuery( '[data-toggle="tooltip"]' ).tooltip();
        }
    };
    dvp.forms = {
        bindEvents: function () {
            jQuery( '.js-e-form-dw' ).each( function () {
                if ( jQuery( this ).find( 'select[name="MailRecipient"]' ).length > 0 && jQuery( this ).find( 'input[name="MailRecipientLabel"]' ).length > 0 ) {
                    var jMailRecipientLabelField = jQuery( this ).find( 'input[name="MailRecipientLabel"]' );

                    jQuery( this ).on( 'change', 'select[name="MailRecipient"]', function () {
                        jMailRecipientLabelField.val( jQuery( 'option:selected', this ).text().trim() );
                    } );
                }
            } );
        },
        init: function () {
            if ( jQuery( '.js-e-form-dw' ).length > 0 ) {
                dvp.forms.bindEvents();
            }
        }
    };
    dvp.extranet = {
        addRules: function () {
            jQuery.validator.addMethod( 'userregex', function ( value, element, regexp ) {
                var re = new RegExp( regexp );
                return this.optional( element ) || re.test( value );
            } );
        },
        addValidation: function () {
            var jExtranetForms = jQuery( 'form[name="UserManagementEditForm"], .js-validate-password-recovery' );
            jExtranetForms.validate( {
                ignore: '.ignore',
                rules: {
                    AccessUserEmail: {
                        required: true,
                        email: true
                    },
                    UserManagement_Form_Email: {
                        required: true,
                        email: true
                    },
                    UserManagement_Form_UserName: {
                        required: true,
                        userregex: '^[a-zA-Z0-9_-]{3,50}$'
                    },
                    UserManagement_Form_OldPassword: {
                        required: function () {
                            return jQuery( 'input[name="UserManagement_Form_NewPassword"]' ).val().length !== 0;
                        }
                    },
                    UserManagement_Form_NewPassword: {
                        minlength: 6,
                    },
                    UserManagement_Form_NewPasswordConfirm: {
                        equalTo: 'input[name="UserManagement_Form_NewPassword"]'
                    },
                    hiddenRecaptcha: {
                        required: function () {
                            if ( grecaptcha.getResponse() === '' ) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                    }
                },
                groups: {
                    UserManagement_Form_Zip: 'UserManagement_Form_Zip UserManagement_Form_City'
                },
                validClass: 'is-valid',
                errorClass: 'is-invalid',
                focusInvalid: false,
                highlight: function ( domElm, strClassError /*, strClassValid */ ) {
                    jQuery( domElm ).addClass( strClassError ).closest( '.form-fields' ).addClass( strClassError );
                },
                unhighlight: function ( domElm, strClassError /*, strClassValid */ ) {
                    jQuery( domElm ).removeClass( strClassError ).closest( '.form-fields' ).removeClass( strClassError );
                },
                errorPlacement: function ( jError, jElement ) {
                    var jFormGroup = jElement.closest( '.form-fields' );
                    jError.addClass( 'form-text small invalid-feedback' );
                    jFormGroup.append( jError );
                },
                invalidHandler: function ( form, validator ) {
                    var jFirstError = jQuery( validator.invalidElements()[ 0 ] );
                    if ( e4.util.isInViewport( jFirstError ) === true ) {
                        validator.focusInvalid();
                    }
                    else {
                        jFirstError.focus();
                        e4.scrollToAnchor.animate( jFirstError.closest( '.form-fields' ).offset().top * 0.875, e4.nav.global.hide );
                    }
                },
                submitHandler: function ( form ) {
                    if ( form.UserManagement_Form_NewPassword.value === '' && form.UserManagement_Form_NewPasswordConfirm.value === '' ) {
                        jExtranetForms.find( ':password' ).prop( 'disabled', true );
                    }
                    else {
                        jExtranetForms.find( ':password' ).filter( function () {
                            return this.value === '';
                        } ).prop( 'disabled', true );
                    }
                    form.submit();
                }
            } );
            if ( jQuery( 'input[name="UserManagement_Form_OldPassword"]' ).length === 1 ) {
                jQuery( 'input[name="UserManagement_Form_NewPassword"]' ).on( 'change keyup', function () {
                    jQuery( 'input[name="UserManagement_Form_OldPassword"]' ).valid();
                } );
            }
        },
        loadTranslations: function () {
            var strLang = e4.settings.lang;
            if ( strLang !== 'en' ) {
                if ( strLang === 'nb' || strLang === 'nn' ) {
                    strLang = 'no';
                }
                else if ( strLang === 'se' ) {
                    strLang = 'sv';
                }
                // Load validation messages from cdn, and then extend if custom messages are set.
                e4.util.require.js( {
                    url: '//ajax.aspnetcdn.com/ajax/jquery.validate/1.17.0/localization/messages_' + strLang + '.js',
                    fallback: '/files/system/espresso/design/js/vendor/jquery.validate.messages_' + strLang + '.js',
                    callback: function () {
                        dvp.extranet.extendTranslations( strLang );
                    }
                } );
            }
            else {
                dvp.extranet.extendTranslations( strLang );
            }
        },
        extendTranslations: function ( strLang ) {
            if ( e4.settings.forms.validate.messages[ strLang ] !== undefined ) {
                jQuery.extend( jQuery.validator.messages, e4.settings.forms.validate.messages[ strLang ] );
            }
        },
        countrySelector: {
            warningMessage: function () {
                var jDechraUserCountrySelector = jQuery( '.js-dechra-user-country-selector' );

                if ( jDechraUserCountrySelector.length > 0 ) {
                    jDechraUserCountrySelector.on( 'change', function () {
                        var strCurrentCountryCode = jQuery( this ).data( 'current-country-code' ),
                            strSelectedCountryCode = this.value;

                        jQuery( '.js-dechra-country-warning-message' ).addClass( 'd-none' );

                        if ( strCurrentCountryCode !== strSelectedCountryCode ) {
                            jQuery( '.js-dechra-country-warning-message' ).removeClass( 'd-none' );
                        }
                    } ).triggerHandler( 'change' );
                }
            }
        },
        editing: {
            checkboxes: function () {
                jQuery( 'form' ).on( 'change', '.js-dechra-checkbox-edit', function () {
                    var jThis = jQuery( this ),
                        strInputName = jThis.data( 'name' ),
                        boolCheckboxState = jThis.is( ':checked' );

                    jQuery( 'input[name="' + strInputName + '"]' ).val( boolCheckboxState ? 'True' : '' );
                } );
            },
            bindEvents: function () {
                dvp.extranet.editing.checkboxes();
            }
        },
        tracking: function () {
            if ( jQuery( '.js-track-new-user-preparation' ).length > 0 && localStorage.getItem( 'DvpNewUser' ) === null ) {
                localStorage.setItem( 'DvpNewUser', true );
            }
            if ( jQuery( '.js-track-new-user-trigger' ).length > 0 && localStorage.getItem( 'DvpNewUser' ) !== null && localStorage.getItem( 'DvpNewUser' ) === 'true' ) {
                localStorage.setItem( 'DvpNewUser', false );
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'dvp-registration',
                    'eventAction': 'register',
                    'eventLabel': 'new-user',
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            }
        },
        login: function () {
            jQuery( 'body' ).on( 'click', '.js-dvp-extranet-login', function () {
                if ( jQuery( this ).hasClass( 'js-dvp-extranet-login-premium-content' ) ) {
                    jQuery( '.dvp-login-modal' ).find( '.js-dvp-login-modal-premium-content' ).removeClass( 'd-none' );
                }
                jQuery( '.dvp-login-modal' ).modal( 'show' );
            } );
            if ( jQuery( '.js-dvp-login-modal-error' ).length > 0 ) {
                jQuery( '.dvp-login-modal' ).modal( 'show' );
            }
            jQuery( '.dvp-login-modal' ).on( 'shown.bs.modal', function () {
                jQuery( 'input', this ).first().focus();
            } );
            jQuery( '.dvp-login-modal' ).on( 'hidden.bs.modal', function () {
                jQuery( '.dvp-login-modal' ).find( '.js-dvp-login-modal-premium-content' ).addClass( 'd-none' );
                if ( jQuery( '.modal.fade:visible' ).length ) {
                    jQuery( 'body' ).addClass( 'modal-open' );
                }
            } );
        },
        init: function () {
            dvp.extranet.login();
            dvp.extranet.tracking();
            e4.util.require.js( e4.settings.require.jQueryValidate, function () {
                dvp.extranet.loadTranslations();
                dvp.extranet.addRules();
                dvp.extranet.addValidation();
            } );
            dvp.extranet.countrySelector.warningMessage();
            dvp.extranet.editing.bindEvents();
            if ( jQuery( '.js-hiddenRecaptcha' ).length > 0 ) {
                e4.util.require.js( {
                    url: '//www.google.com/recaptcha/api.js',
                    fallback: ''
                } );
            }
        }
    };
    dvp.geoIpRedirect = {
        modal: {
            show: function () {
                if ( jQuery( '.dvp-geo-ip-country-modal' ).length > 0 ) {
                    jQuery( '.dvp-geo-ip-country-modal' ).modal();
                }
            },
            dismissed: function () {
                jQuery( '.dvp-geo-ip-country-modal' ).on( 'hide.bs.modal', function () {
                    var geoIpCountry = jQuery( '.js-dvp-geo-ip-dismiss-button' ).data( 'geo-ip-country' );
                    jQuery( '.js-dvp-set-geo-ip-country' ).each( function () {
                        var url = jQuery( this ).attr( 'href' ) + '?geo=' + geoIpCountry;
                        jQuery( this ).attr( 'href', url );
                    } );
                } );
            }
        },
        init: function () {
            dvp.geoIpRedirect.modal.show();
            dvp.geoIpRedirect.modal.dismissed();
        }
    };
    dvp.imageAreaMap = {
        scale: function ( image ) {

            var img = image;

            var imageMap = function () {
                img.each( function () {

                    var jThat = jQuery( this );

                    jQuery( '<img />' ).on( 'load', function () {
                        var attrW = 'width',
                            attrH = 'height',
                            w = jThat.attr( attrW ),
                            h = jThat.attr( attrH );

                        if ( !w || !h ) {
                            var temp = new Image();
                            temp.src = jThat.attr( 'src' );
                            if ( !w ) {
                                w = temp.width;
                            }
                            if ( !h ) {
                                h = temp.height;
                            }
                        }

                        var wPercent = jThat.width() / 100,
                            hPercent = jThat.height() / 100,
                            map = jThat.attr( 'usemap' ).replace( '#', '' ),
                            c = 'coords';

                        jQuery( 'map[name="' + map + '"]' ).find( 'area' ).each( function () {
                            var jThis = jQuery( this );
                            if ( !jThis.data( c ) ) {
                                jThis.data( c, jThis.attr( c ) );
                            }

                            var coords = jThis.data( c ).split( ',' ),
                                coordsPercent = new Array( coords.length );

                            for ( var i = 0; i < coordsPercent.length; ++i ) {
                                if ( i % 2 === 0 ) {
                                    coordsPercent[ i ] = parseInt( ( ( coords[ i ] / w ) * 100 ) * wPercent );
                                }
                                else {
                                    coordsPercent[ i ] = parseInt( ( ( coords[ i ] / h ) * 100 ) * hPercent );
                                }
                            }
                            jThis.attr( c, coordsPercent.toString() );
                        } );
                    } ).attr( 'src', jThat.attr( 'src' ) );
                } );
            };
            jQuery( window ).resize( imageMap ).trigger( 'resize' );

            return this;
        },
        init: function () {
            if ( jQuery( 'img[usemap]' ).length > 0 ) {
                dvp.imageAreaMap.scale( jQuery( 'img[usemap]' ) );
            }
        }
    };
    dvp.pageModal = {
        modalClass: '.js-dvp-page-modal',
        key: '',
        days: 0,
        trigger: function () {
            if ( jQuery.cookie( dvp.pageModal.key ) === undefined ) {
                jQuery( dvp.pageModal.modalClass ).modal();
            }
        },
        bindEvents: function () {
            jQuery( dvp.pageModal.modalClass ).on( 'hide.bs.modal', function () {
                var objOptions = {
                    path: '/'
                };

                if ( dvp.pageModal.days > 0 ) {
                    objOptions = {
                        path: '/',
                        expires: dvp.pageModal.days
                    };
                }

                jQuery.cookie( dvp.pageModal.key, 'Accepted', objOptions );
            } );
        },
        init: function () {
            if ( jQuery( dvp.pageModal.modalClass ).length > 0 ) {
                dvp.pageModal.key = jQuery( dvp.pageModal.modalClass ).data( 'key' );
                dvp.pageModal.days = jQuery( dvp.pageModal.modalClass ).data( 'days' );
                dvp.pageModal.trigger();
                dvp.pageModal.bindEvents();
            }
        }
    };
    dvp.timeline = {
        data: {},
        betterData: {},
        filteredData: {},
        filterType: [],
        filterCountry: [],
        strStaticParentClass: '.js-dvp-timeline',
        get: function ( id, name ) {
            if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                this.jqXHR.abort();
            }
            this.jqXHR = jQuery.ajax( {
                url: 'https://sheets.googleapis.com/v4/spreadsheets/' + id + '/values/' + name,
                data: {
                    alt: 'json',
                    key: 'AIzaSyCshpU-MiIFUkyyyUpMljQv8OgqSEJmYTE'
                },
                method: 'GET',
                dataType: 'json',
                cache: false
            } );
            this.jqXHR.done( function ( data ) {
                dvp.timeline.data = data;
                dvp.timeline.restructureData( dvp.timeline.data );
            } );
            return this.jqXHR;
        },
        abort: function () {
            if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                return this.jqXHR.abort();
            }
            return jQuery.Deferred().reject();
        },
        bindings: function () {
            jQuery( dvp.timeline.strStaticParentClass ).on( 'change', '.js-dvp-timeline-slider', function () {
                dvp.timeline.filter();
            } );
            jQuery( dvp.timeline.strStaticParentClass ).on( 'click', '.js-dvp-timeline-filter-type', function () {

                var reset = true,
                    resetAll = false;


                if ( jQuery( this ).hasClass( 'js-dvp-timeline-reset-filter-type' ) && !jQuery( this ).hasClass( 'active' ) ) {
                    resetAll = true;
                }

                jQuery( '.js-dvp-timeline-filter-type' ).each( function () {
                    if ( resetAll ) {
                        jQuery( this ).find( 'input[type="checkbox"]' ).prop( 'checked', false );
                        jQuery( this ).removeClass( 'active' );
                    }
                    else {
                        if ( jQuery( this ).find( 'input[type="checkbox"]' ).is( ':checked' ) ) {
                            jQuery( this ).addClass( 'active' );
                            jQuery( '.js-dvp-timeline-reset-filter-type' ).removeClass( 'active' );
                            reset = false;
                        }
                        else {
                            jQuery( this ).removeClass( 'active' );
                        }
                    }
                } );

                if ( reset ) {
                    jQuery( '.js-dvp-timeline-reset-filter-type' ).addClass( 'active' );
                }

                dvp.timeline.filter();
            } );
            jQuery( dvp.timeline.strStaticParentClass ).on( 'click', '.js-dvp-timeline-filter-country', function () {

                var reset = true,
                    resetAll = false;


                if ( jQuery( this ).hasClass( 'js-dvp-timeline-reset-filter-country' ) && !jQuery( this ).hasClass( 'active' ) ) {
                    resetAll = true;
                }

                jQuery( '.js-dvp-timeline-filter-country' ).each( function () {
                    if ( resetAll ) {
                        jQuery( this ).find( 'input[type="checkbox"]' ).prop( 'checked', false );
                        jQuery( this ).removeClass( 'active' );
                    }
                    else {
                        if ( jQuery( this ).find( 'input[type="checkbox"]' ).is( ':checked' ) ) {
                            jQuery( this ).addClass( 'active' );
                            jQuery( '.js-dvp-timeline-reset-filter-country' ).removeClass( 'active' );
                            reset = false;
                        }
                        else {
                            jQuery( this ).removeClass( 'active' );
                        }
                    }
                } );

                if ( reset ) {
                    jQuery( '.js-dvp-timeline-reset-filter-country' ).addClass( 'active' );
                }

                dvp.timeline.filter();
            } );
            jQuery( dvp.timeline.strStaticParentClass ).on( 'click', '.js-dvp-timeline-scrollto', function ( e ) {
                e.preventDefault();
                e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( this.hash ) );
            } );
            jQuery( dvp.timeline.strStaticParentClass ).on( 'click', '.js-dvp-timeline-filter-group-toggle-button', function () {
                jQuery( this ).toggleClass( 'open' );
                jQuery( dvp.timeline.strStaticParentClass ).find( '.js-dvp-timeline-filter-group' ).toggleClass( 'dvp-timeline-filter-group-visible' );
                if ( jQuery( dvp.timeline.strStaticParentClass ).find( '.js-dvp-timeline-filter-group' ).hasClass( 'dvp-timeline-filter-group-visible' ) ) {
                    e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '#dvp-timeline-reset-scroll' ) );
                }
            } );
        },
        restructureData: function ( data ) {
            if ( data.values.length > 0 ) {
                var headers = [];
                var firstRow = {
                    Filters: {
                        Types: [],
                        Countries: []
                    },
                    Title: '',
                    Text: '',
                    Image: '',
                    Timeline: []
                };
                for ( var rowI = 0; rowI < data.values.length; rowI++ ) {

                    var timeline = { Year: 0, DisplayDate: '', Title: '', Text: '', Image: '', Type: [], Countries: [] };

                    var row = data.values[ rowI ];
                    for ( var colI = 0; colI < row.length; colI++ ) {
                        if ( row[ 0 ] !== '' ) {
                            if ( rowI === 0 ) {
                                headers.push( row[ colI ] );
                            }
                            else if ( rowI === 1 ) {
                                if ( headers[ colI ] === 'Headline' ) {
                                    firstRow.Title = row[ colI ];
                                }
                                else if ( headers[ colI ] === 'Text' ) {
                                    firstRow.Text = row[ colI ];
                                }
                                else if ( headers[ colI ] === 'Media' ) {
                                    firstRow.Image = row[ colI ];
                                }
                            }
                            else {
                                if ( headers[ colI ] === 'Start Date' ) {
                                    timeline.Year = row[ colI ];
                                }
                                else if ( headers[ colI ] === 'Display Date' ) {
                                    timeline.DisplayDate = row[ colI ];
                                }
                                else if ( headers[ colI ] === 'Headline' ) {
                                    timeline.Title = row[ colI ];
                                }
                                else if ( headers[ colI ] === 'Text' ) {
                                    timeline.Text = row[ colI ];
                                }
                                else if ( headers[ colI ] === 'Media' ) {
                                    timeline.Image = row[ colI ];
                                }
                                else if ( headers[ colI ] === 'Tag' ) {
                                    timeline.Type = row[ colI ].split( ',' );

                                    if ( row[ colI ] !== '' ) {
                                        for ( var tI = 0; tI < timeline.Type.length; tI++ ) {
                                            if ( dvp.timeline.filterType.indexOf( timeline.Type[ tI ] ) === -1 ) {
                                                dvp.timeline.filterType.push( row[ colI ] );
                                            }
                                        }
                                    }
                                }
                                else if ( headers[ colI ] === 'Country' ) {
                                    timeline.Countries = row[ colI ].split( ',' );

                                    if ( row[ colI ] !== '' ) {
                                        for ( var cI = 0; cI < timeline.Countries.length; cI++ ) {
                                            if ( dvp.timeline.filterCountry.indexOf( timeline.Countries[ cI ] ) === -1 ) {
                                                dvp.timeline.filterCountry.push( timeline.Countries[ cI ] );
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if ( timeline.Title !== '' ) {
                        firstRow.Timeline.push( timeline );
                    }
                }
                firstRow.Filters.Types = dvp.timeline.filterType;
                firstRow.Filters.Countries = dvp.timeline.filterCountry;

                dvp.timeline.betterData = firstRow;
                dvp.timeline.updateAll( dvp.timeline.betterData );
            }
            else {
                console.log( 'No data found.' );
            }
        },
        filter: function () {
            var timelineSliderValue = jQuery( '.js-dvp-timeline-slider' ).val();

            var timelineFilterTypeValues = [];

            jQuery( '.js-dvp-timeline-filter-type' ).find( 'input[type="checkbox"]' ).each( function () {
                if ( jQuery( this ).is( ':checked' ) ) {
                    if ( jQuery( this ).val() !== '' ) {
                        timelineFilterTypeValues.push( jQuery( this ).val() );
                    }
                }
            } );

            var timelineFilterCountryValues = [];

            jQuery( '.js-dvp-timeline-filter-country' ).find( 'input[type="checkbox"]' ).each( function () {
                if ( jQuery( this ).is( ':checked' ) ) {
                    if ( jQuery( this ).val() !== '' ) {
                        timelineFilterCountryValues.push( jQuery( this ).val() );
                    }
                }
            } );

            dvp.timeline.filteredData = dvp.timeline.betterData.Timeline.filter( function ( item ) {
                return item.Year >= timelineSliderValue &&
                    item.Type.some( function ( v ) {
                        if ( timelineFilterTypeValues.length > 0 ) {
                            return timelineFilterTypeValues.indexOf( v ) >= 0;
                        }
                        else {
                            return true;
                        }
                    } ) &&
                    item.Countries.some( function ( v ) {
                        if ( timelineFilterCountryValues.length > 0 ) {
                            return timelineFilterCountryValues.indexOf( v ) >= 0;
                        }
                        else {
                            return true;
                        }
                    } );
            } );

            dvp.timeline.updatePartial( { Timeline: dvp.timeline.filteredData } );
        },
        updateAll: function ( data ) {
            jQuery( dvp.timeline.strStaticParentClass ).html( e4.handlebars.tmpl.timeline( data ) );
            dvp.timeline.bindings();
        },
        updatePartial: function ( data ) {
            jQuery( '.js-dvp-timeline-items' ).html( e4.handlebars.partial.timelineItems( data ) );
        },
        init: function () {
            if ( jQuery( dvp.timeline.strStaticParentClass ).length > 0 ) {
                if ( jQuery( dvp.timeline.strStaticParentClass ).data( 'sheet-id' ) !== '' && jQuery( dvp.timeline.strStaticParentClass ).data( 'sheet-name' ) !== '' ) {
                    e4.util.require.js( e4.settings.require.handlebars, function () {
                        e4.handlebars.registerPartials( '#js-e-handlebars-partial-timeline-items' );
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-timeline' );
                        e4.handlebars.registerHelpers( 'compare' );
                        e4.handlebars.registerHelpers( 'math' );
                        dvp.timeline.get( jQuery( dvp.timeline.strStaticParentClass ).data( 'sheet-id' ), jQuery( dvp.timeline.strStaticParentClass ).data( 'sheet-name' ) );
                    } );
                }
                else {
                    jQuery( dvp.timeline.strStaticParentClass ).html( '' );
                }
            }
        }
    };
}() );
